import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Statuses from './statuses';
import StatusesDetail from './statuses-detail';
import StatusesUpdate from './statuses-update';
import StatusesDeleteDialog from './statuses-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={StatusesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={StatusesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={StatusesDetail} />
      <ErrorBoundaryRoute path={match.url} component={Statuses} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={StatusesDeleteDialog} />
  </>
);

export default Routes;
